import React from 'react';

import createSvgIcon from './hoc/createSvgIcon';

export default createSvgIcon(
  () => (
    <>
      <svg
        width="90%"
        height="90%"
        viewBox="0 0 240 240"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          strokeLinejoin: 'round',
          strokeMiterlimit: 2,
        }}
      >
        <g id="layer101">
          <path
            d="M92.5,219.5c-11.3,-2 -20.8,-5.2 -31.2,-10.5c-66,-33.3 -81.2,-120.8 -30.2,-174.4c9.9,-10.4 18.3,-16.7 31.4,-23.1c30.9,-15.3 67.2,-15.3 97.9,0.1c10.9,5.5 17.4,10.2 27.3,19.7c14.7,14.2 24.1,29.7 29.7,49.1c4.1,14.1 7.2,12.6 -26.8,12.6l-29.5,0l-2.6,-5.2c-9.5,-18.9 -26.7,-29.7 -47.2,-29.8c-8.4,0 -15.5,1.6 -23.3,5.3c-8.6,4 -19.4,14.8 -23.9,23.7l-3.2,6.5l13.1,0.3l13,0.3l3.1,-3.5c1.7,-1.9 5.6,-4.8 8.6,-6.3c18.9,-9.2 41.3,5.1 41.3,26.2c0,18.1 -17,32.1 -34.3,28.5c-6.9,-1.4 -13.9,-5.8 -17.4,-10.9l-2.8,-4l-12.7,-0.1l-12.8,0l1.9,5c6.1,16.1 21.5,29.5 37.9,32.9c24.3,5.1 47.4,-6.3 58.7,-28.7l2.6,-5.2l29.5,0c34,0 30.9,-1.5 26.8,12.6c-5.6,19.4 -15,34.9 -29.7,49.1c-13.2,12.7 -25.4,20.2 -41.8,25.7c-16,5.4 -37.6,7 -53.4,4.1Z"
            style={{ fill: '#6abd45', fillRule: 'nonzero' }}
          />
        </g>
      </svg>
    </>
  ),
  'PlanetEStream',
  '0 0 120 120'
);
